import { render } from "./Member_Sponsors.vue?vue&type=template&id=2a08fce6"
import script from "./Member_Sponsors.vue?vue&type=script&lang=js"
export * from "./Member_Sponsors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__